import React, { useState } from "react";
import { Link } from "react-router-dom";
import viFlag from "../../Components/flags/vn.png";
import enFlag from "../../Components/flags/us.png";

import teamImage from "../../assets/images/team.png";
import feature1 from "../../assets/icons/4k.svg";
import feature2 from "../../assets/icons/multi-device.svg";
import feature3 from "../../assets/icons/no-ads.svg";
import "./style.css";

const content = {
  vi: {
    title: "Về chúng tôi",
    subtitle: "Nền tảng xem phim hàng đầu",
    description:
      "Bagalaxy là nền tảng xem phim trực tuyến chất lượng cao...",
    missionTitle: "Sứ mệnh",
    mission: "Mang đến trải nghiệm giải trí đỉnh cao...",
    visionTitle: "Tầm nhìn",
    vision: "Trở thành nền tảng phát trực tuyến hàng đầu...",
    featuresTitle: "Tại sao chọn Bagalaxy?",
    features: [
      { icon: feature1, title: "Chất lượng 4K", description: "Hình ảnh sắc nét..." },
      { icon: feature2, title: "Đa nền tảng", description: "Xem phim mọi nơi" },
      { icon: feature3, title: "Không quảng cáo", description: "Không bị gián đoạn" },
    ],
    cta: "Khám phá ngay",
    teamTitle: "Đội ngũ của chúng tôi",
    teamText: "Chúng tôi là những người yêu điện ảnh..."
  },
  en: {
    title: "About Us",
    subtitle: "The Premier Movie Platform",
    description: "Bagalaxy is a high-quality movie streaming platform...",
    missionTitle: "Our Mission",
    mission: "To deliver a top-notch, user-friendly experience.",
    visionTitle: "Our Vision",
    vision: "To become the leading platform in Vietnam.",
    featuresTitle: "Why Choose Bagalaxy?",
    features: [
      { icon: feature1, title: "4K Quality", description: "Crystal clear visuals" },
      { icon: feature2, title: "Multi-Platform", description: "Watch anywhere" },
      { icon: feature3, title: "Ad-Free", description: "No interruptions" },
    ],
    cta: "Explore Now",
    teamTitle: "Our Team",
    teamText: "We are movie lovers dedicated to quality..."
  }
};

const About = () => {
  const [language, setLanguage] = useState("vi");

  return (
    <div className="about-container">
      {/* Header */}
      <div className="about-header">
        <h1 className="title">{content[language].title}</h1>
        <p className="subtitle">{content[language].subtitle}</p>
        <div className="language-switch">
          <img
            src={viFlag}
            alt="VN"
            className={language === "vi" ? "active" : ""}
            onClick={() => setLanguage("vi")}
          />
          <img
            src={enFlag}
            alt="EN"
            className={language === "en" ? "active" : ""}
            onClick={() => setLanguage("en")}
          />
        </div>
        <p className="mt-4">{content[language].description}</p>
        <Link to="/movies" className="mt-4 inline-block">{content[language].cta}</Link>
      </div>

      {/* Mission & Vision */}
      <div className="about-section">
        <div className="about-box">
          <h2>{content[language].missionTitle}</h2>
          <p>{content[language].mission}</p>
        </div>
        <div className="about-box">
          <h2>{content[language].visionTitle}</h2>
          <p>{content[language].vision}</p>
        </div>
      </div>

      {/* Features */}
      <div className="about-section">
        <h2 className="text-center text-2xl font-bold mb-6">{content[language].featuresTitle}</h2>
        <div className="features-grid">
          {content[language].features.map((f, i) => (
            <div key={i} className="feature-card">
              <img src={f.icon} alt={f.title} />
              <h3>{f.title}</h3>
              <p>{f.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Team */}
      <div className="about-section text-center team-section">
        <h2 className="text-2xl font-bold mb-4">{content[language].teamTitle}</h2>
        <img src={teamImage} alt="team" />
        <p>{content[language].teamText}</p>
      </div>

      {/* CTA */}
      <div className="cta-section">
        <h2>
          {language === "vi"
            ? "Sẵn sàng khám phá thế giới điện ảnh?"
            : "Ready to explore the cinematic world?"}
        </h2>
        <Link to="/movies">
          {language === "vi" ? "Xem phim ngay" : "Browse Movies"}
        </Link>
      </div>
    </div>
  );
};

export default About;
